import { withInstall } from '@jdesign-vue/utils'
import Autocomplete from './src/autocomplete.vue'

export const JdAutocomplete = withInstall(Autocomplete)

export default JdAutocomplete

export * from './src/autocomplete'
